var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "controls__bar",
      class: [_vm.controlActive ? "expanded" : ""]
    },
    [
      _c("position-control", {
        staticClass: "stick-top-left w-100 controls__bar__item",
        attrs: {
          fullscreen: _vm.videoPlayerStoreState.fullscreen,
          position: _vm.videoPlayerStoreState.position,
          duration: _vm.videoPlayerStoreState.duration,
          expanded: _vm.controlActive
        },
        on: { setPosition: _vm.setPosition, dragstart: _vm.player.pause }
      }),
      _vm._v(" "),
      _vm.videoPlayerStoreState.state === "playing"
        ? _c("VsButton", {
            staticClass:
              "\n      controls__bar__item\n      item--small-icon\n    ",
            attrs: {
              tracker: _vm.getAnalyticPayload(function(e) {
                return e.player["control-bar"].click.pause
              }, ""),
              icon: "md:pause"
            },
            nativeOn: {
              click: function($event) {
                return _vm.player.pause($event)
              }
            }
          })
        : _vm.videoPlayerStoreState.state === "complete"
        ? _c("VsButton", {
            staticClass:
              "\n      controls__bar__item\n      controls__bar__item--complete\n      item--small-icon\n    ",
            attrs: {
              tracker: _vm.getAnalyticPayload(function(e) {
                return e.player["control-bar"].click.rewind
              }, ""),
              icon: "md:refresh"
            },
            nativeOn: {
              click: function($event) {
                return _vm.player.seek(0)
              }
            }
          })
        : _c("VsButton", {
            staticClass:
              "\n      controls__bar__item\n      item--small-icon\n    ",
            attrs: {
              tracker: _vm.getAnalyticPayload(function(e) {
                return e.player["control-bar"].click.play
              }, ""),
              icon: "md:play_arrow"
            },
            nativeOn: {
              click: function($event) {
                return _vm.player.play($event)
              }
            }
          }),
      _vm._v(" "),
      _c("volume-control", {
        staticClass: "controls__bar__item item--small-icon",
        attrs: {
          volume: _vm.videoPlayerStoreState.volume,
          mute: _vm.videoPlayerStoreState.mute
        },
        on: {
          setVolume: _vm.handleVolumeSet,
          toggleMute: function() {
            return _vm.player.setMute()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "controls__bar__item px-3 controls__bar__duration" },
        [
          _c("DurationIndicator", {
            attrs: { duration: _vm.videoPlayerStoreState.position }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(" / ")]),
          _vm._v(" "),
          _c("DurationIndicator", {
            attrs: { duration: _vm.videoPlayerStoreState.duration }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml-auto d-flex" },
        [
          _c("captions-control", {
            staticClass: "controls__bar__item item--small-icon",
            attrs: {
              "current-captions": _vm.videoPlayerStoreState.currentCaptions,
              "captions-list": _vm.videoPlayerStoreState.captionsList
            },
            on: { captionsChanged: _vm.player.setCurrentCaptions }
          }),
          _vm._v(" "),
          _c("quality-control", {
            staticClass: "controls__bar__item item--small-icon",
            attrs: {
              "current-quality": _vm.videoPlayerStoreState.currentQuality,
              "visual-quality": _vm.videoPlayerStoreState.visualQuality,
              "quality-levels": _vm.videoPlayerStoreState.qualityLevels
            },
            on: { levelChanged: _vm.player.setCurrentQuality }
          }),
          _vm._v(" "),
          _c("speed-control", {
            staticClass: "controls__bar__item item--small-icon",
            attrs: { "playback-speed": _vm.videoPlayerStoreState.playbackRate },
            on: { speedChanged: _vm.player.setPlaybackRate }
          }),
          _vm._v(" "),
          _c("chromecast-control", {
            staticClass:
              "\n        controls__bar__item\n        controls__bar__item--complete\n        item--small-icon d-flex\n      "
          }),
          _vm._v(" "),
          _c("VsButton", {
            staticClass: "controls__bar__item item--small-icon",
            class: [
              _vm.videoPlayerStoreState.fullscreen
                ? "controls__bar__item--complete"
                : ""
            ],
            attrs: {
              tracker: _vm.getAnalyticPayload(function(e) {
                return e.player["control-bar"].click.fullscreen
              }, ""),
              icon:
                "md:fullscreen" +
                (_vm.videoPlayerStoreState.fullscreen ? "_exit" : "")
            },
            nativeOn: {
              click: function($event) {
                return _vm.toggleFullscreen($event)
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass:
              "d-none d-sm-block\n        controls__bar__item item--small-icon vs-icon",
            staticStyle: {
              width: "18px",
              height: "24px",
              "box-sizing": "content-box",
              opacity: "0.8"
            },
            attrs: { src: require("@/images/player/viddsee-logo.svg") },
            on: {
              click: function($event) {
                _vm.analytic.send(
                  _vm.getAnalyticPayload(function(e) {
                    return e.player["control-bar"].click["viddsee-icon"]
                  }, "")
                )
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }